document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".pr-faq__item");

  faqItems.forEach((item) => {
    const summary = item.querySelector("summary");
    const content = item.querySelector(".pr-faq__answer");

    // Prepare animation
    content.style.overflow = "hidden";
    content.style.transition = "height 0.35s ease, opacity 0.25s ease";

    if (!item.open) {
      content.style.height = "0px";
      content.style.opacity = "0";
    } else {
      content.style.height = content.scrollHeight + "px";
      content.style.opacity = "1";
    }

    summary.addEventListener("click", function (e) {
      e.preventDefault();

      const isOpen = item.open;

      // OPTIONAL: Close others (true accordion behavior)
      faqItems.forEach((otherItem) => {
        if (otherItem !== item && otherItem.open) {
          const otherContent = otherItem.querySelector(".pr-faq__answer");
          otherContent.style.height = otherContent.scrollHeight + "px";
          requestAnimationFrame(() => {
            otherContent.style.height = "0px";
            otherContent.style.opacity = "0";
          });
          otherItem.open = false;
        }
      });

      if (!isOpen) {
        item.open = true;
        content.style.height = content.scrollHeight + "px";
        content.style.opacity = "1";
      } else {
        content.style.height = content.scrollHeight + "px";
        requestAnimationFrame(() => {
          content.style.height = "0px";
          content.style.opacity = "0";
        });
        item.open = false;
      }
    });
  });
});
